import { render, staticRenderFns } from "./consume_record.vue?vue&type=template&id=5ee24db0&"
import script from "./consume_record.vue?vue&type=script&lang=js&"
export * from "./consume_record.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports